var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExceptNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 10 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2515",
    transform: "translate(-505 -210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Production_1_",
    transform: "translate(576.8 3262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71_1_",
    transform: "translate(1 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88_1_",
    className: "cls-2",
    d: "M-64.2-3044.4H-63v11.4a5.291,5.291,0,0,0,2.1-1.1l.6.4a10.352,10.352,0,0,1,7.3-2.7,10.819,10.819,0,0,1,7.3,2.7l.6-.4A6.986,6.986,0,0,0-43-3033v-11.4h1.2a.43.43,0,0,0,.4-.4h0v-3.8a.43.43,0,0,0-.4-.4h-5a.43.43,0,0,0-.4.4h0v3.8a.43.43,0,0,0,.4.4h1.2v4a7.005,7.005,0,0,1,1.9,3.6c0,.1,0,.1-.1.1-1.3-2.9-4.9-5-9.1-5s-7.8,2.1-9.1,5c0,0-.1,0-.1-.2a7.112,7.112,0,0,1,1.9-3.5v-4H-59a.43.43,0,0,0,.4-.4v-3.8a.43.43,0,0,0-.4-.4h-5a.43.43,0,0,0-.4.4v3.8C-64.6-3044.6-64.4-3044.4-64.2-3044.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89_1_",
    className: "cls-2",
    d: "M-42.6-3032.1a5.681,5.681,0,0,1-2.2-.7l-.4-.3-.4.3a4.4,4.4,0,0,1-2.2.7,5.681,5.681,0,0,1-2.2-.7l-.4-.3-.4.3a4.4,4.4,0,0,1-2.2.7,5.681,5.681,0,0,1-2.2-.7l-.4-.3-.4.3a4.4,4.4,0,0,1-2.2.7,5.19,5.19,0,0,1-2.2-.7l-.4-.3-.4.3a4.4,4.4,0,0,1-2.2.7,3.53,3.53,0,0,1-1.4-.3v1.6a5.9,5.9,0,0,0,1.4.2,5.941,5.941,0,0,0,2.6-.7,5.941,5.941,0,0,0,2.6.7,5.941,5.941,0,0,0,2.6-.7,5.941,5.941,0,0,0,2.6.7,5.941,5.941,0,0,0,2.6-.7,5.941,5.941,0,0,0,2.6.7,5.941,5.941,0,0,0,2.6-.7,5.941,5.941,0,0,0,2.6.7,6.762,6.762,0,0,0,1.4-.2v-1.6A3.191,3.191,0,0,1-42.6-3032.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExceptNav);
export default __webpack_public_path__ + "static/media/except-nav.d7dcbf8c2e11f7bd0c5e5b04c0f5e1a5.svg";
export { ForwardRef as ReactComponent };